// src/ones/OnePastor.js
import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { MdPerson, MdPlace, MdChurch } from "react-icons/md";
import { STR_FROM_DESTINATION, STR_TO_DESTINATION } from "../Strings";
import { FaLocationArrow } from "react-icons/fa6";
import { FaMapMarkerAlt } from "react-icons/fa";
import { formatMoney } from "../Helpers";

export default function OneRideRequest({data, viewer='user'}) {

	const appContext = useContext(AppContext);

	const [fromDestination, setFromDestination] = useState(null);
	const [toDestination, setToDestination] = useState(null);

	function view() {
		if(viewer === 'rider') {
			appContext.navTo({
				item: 'side-view',
				subItem: 'rider-view-ride-request',
				moreItem: data.uuid,
			})
		} else {
			appContext.navTo({
				item: 'side-view',
				subItem: 'view-ride-request',
				moreItem: data.uuid,
			})
		}
	}

	useEffect(() => {
		if(data) {
			setFromDestination(JSON.parse(data.fromDestination));
			setToDestination(JSON.parse(data.toDestination));
		}
	}, [ data ])

	return (
		<div
			style={{
				width: "100%",
				marginBottom: "20px",
				padding: "15px",
				cursor: "pointer",
				borderRadius: "15px",
			}}
			className="bg-surface"
			onClick={view}
		>
			
			<h6
				style={{
					fontSize: "32px"
				}}
				className="font-light text-muted mb-3"
			>
				{(data.totalDistance).toFixed(2)} Km
			</h6>

			<h6
				style={{
					fontSize: "14px",
					marginBottom: "20px"
				}}
				className="font-regular"
			>
				
				<span
					className="font-bold text-muted d-block"
					style={{
						fontSize: "12px"
					}}
				>
					{STR_FROM_DESTINATION[appContext.language]}
				</span>

				<div className="d-flex">
					<FaLocationArrow className="flex-shrink-0 m-2 align-self-center" size={24}/>
					<span className="align-self-center">{fromDestination?.description || 'N/A'}</span>
				</div>
			</h6>

			<h6
				style={{
					fontSize: "14px",

				}}
				className="font-regular"
			>
				<span
					className="font-bold text-muted d-block"
					style={{
						fontSize: "12px"
					}}
				>
					{STR_TO_DESTINATION[appContext.language]}
				</span>

				

				<div className="d-flex">
					<FaMapMarkerAlt className="flex-shrink-0 m-2 align-self-center" size={24}/>
					<span className="align-self-center">{toDestination?.description || 'N/A'}</span>
				</div>
			</h6>

			<h6
				style={{
					fontSize: "32px"
				}}
				className="font-bold text-secondary text-end"
			>
				{formatMoney(data.overallCost)}
				<span
					className="d-block"
					style={{
						fontSize: "16px"
					}}
				>
					TZS
				</span>
			</h6>

			
		</div>
	)
}
